import { render, staticRenderFns } from "./ApplicationPerson.vue?vue&type=template&id=b1a8b728&"
import script from "./ApplicationPerson.vue?vue&type=script&lang=js&"
export * from "./ApplicationPerson.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports